import * as RD from '@radix-ui/react-dialog';
import type { ReactNode } from 'react';

interface ModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description?: string;
  children: ReactNode;
}

export function Modal({ open, onOpenChange, title, description, children }: ModalProps) {
  return (
    <RD.Root open={open} onOpenChange={onOpenChange}>
      <RD.Portal>
        <RD.Overlay className="dialog-overlay" />
        <RD.Content className="modal-content">
          <RD.Title className="dialog-title">{title}</RD.Title>
          {description ? (
            <RD.Description className="muted" style={{ marginBlockStart: 'var(--space-2)' }}>
              {description}
            </RD.Description>
          ) : null}
          <div style={{ marginBlockStart: 'var(--space-4)' }}>{children}</div>
        </RD.Content>
      </RD.Portal>
    </RD.Root>
  );
}
